export default {
  vendorListVersion: 153,
  lastUpdated: '2019-06-27T16:00:16Z',
  purposes: [
    {
      id: 1,
      name: 'Information storage and access'
    },
    {
      id: 2,
      name: 'Personalisation'
    },
    {
      id: 3,
      name: 'Ad selection, delivery, reporting'
    },
    {
      id: 4,
      name: 'Content selection, delivery, reporting'
    },
    {
      id: 5,
      name: 'Measurement'
    }
  ],
  vendors: [
    {id: 40, name: 'Active Agent AG', checked: true},
    {id: 57, name: 'ADARA MEDIA UNLIMITED', checked: true},
    {id: 50, name: 'Adform A/S', checked: true},
    {id: 264, name: 'Adobe Advertising Cloud', checked: true},
    {id: 565, name: 'Adobe Audience Manager', checked: true},
    {id: 130, name: 'AdRoll Inc', checked: true},
    {id: 23, name: 'Amobee, Inc.', checked: true},
    {id: 32, name: 'AppNexus Inc.', checked: true},
    {id: 128, name: 'BIDSWITCH GmbH', checked: true},
    {id: 156, name: 'Centro, Inc.', checked: true},
    {id: 85, name: 'Crimtan Holdings Limited', checked: true},
    {id: 91, name: 'Criteo SA', checked: true},
    {id: 570, name: 'Czech Publisher Exchange z.s.p.o.', checked: true},
    {id: 71, name: 'Dataxu, Inc.', checked: true},
    {id: 64, name: 'DigiTrust / IAB Tech Lab', checked: true},
    {id: 126, name: 'DoubleVerify Inc.', checked: true},
    {id: 29, name: 'Etarget SE', checked: true},
    {id: 1, name: 'Exponential Interactive', checked: true},
    {id: 328, name: 'Gemius SA', checked: true},
    {id: 98, name: 'GroupM', checked: true},
    {id: 10, name: 'Index Exchange, Inc.', checked: true},
    {id: 278, name: 'Integral Ad Science, Inc.', checked: true},
    {id: 428, name: 'Internet BillBoard a.s.', checked: true},
    {id: 129, name: 'IPONWEB GmbH', checked: true},
    {id: 317, name: 'MainADV Srl', checked: true},
    {id: 79, name: 'MediaMath, Inc.', checked: true},
    {id: 25, name: 'Oath (EMEA) Limited', checked: true},
    {id: 69, name: 'OpenX', checked: true},
    {id: 732, name: 'Performax', checked: true},
    {id: 177, name: 'Plista GmbH', checked: true},
    {id: 76, name: 'PubMatic, Inc.', checked: true},
    {id: 16, name: 'RTB House S.A.', checked: true},
    {id: 621, name: 'Seznam.cz, a.s.', checked: true},
    {id: 68, name: 'Sizmek Technologies, Inc.', checked: true},
    {id: 45, name: 'Smart Adserver', checked: true},
    {id: 338, name: 'dunnhumby Germany GmbH - Sociomantic', checked: true},
    {id: 136, name: 'Ströer SSP GmbH', checked: true},
    {id: 42, name: 'Taboola Europe Limited', checked: true},
    {id: 132, name: 'Teads', checked: true},
    {id: 52, name: 'The Rubicon Project, Limited', checked: true},
    {id: 21, name: 'The Trade Desk', checked: true},
    {id: 423, name: 'travel audience GmbH', checked: true},
    {id: 592, name: 'Colpirio', checked: true},
    {id: 366, name: 'Cerebro', checked: true},
    {id: 205, name: 'Adssets', checked: true},
    {id: 238, name: 'Stackadapt', checked: true},
    {id: 73, name: 'Simplifi Holdings Inc.', checked: true},
    {id: 97, name: 'LiveRamp, Inc.', checked: true},
    {id: 373, name: 'Nielsen Marketing Cloud', checked: true},
    {id: 385, name: 'Oracle', checked: true}
  ]
};
